import { render, staticRenderFns } from "./PropImpressionsTotal.vue?vue&type=template&id=d586a07a&"
import script from "./PropImpressionsTotal.vue?vue&type=script&lang=js&"
export * from "./PropImpressionsTotal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports